import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  hotIndex: number;
  readCount: string;
  imageUrl: string;
}

export default function ArticleCard({
  id,
  title,
  excerpt,
  category,
  categorySlug,
  hotIndex,
  readCount,
  imageUrl,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-300 flex-shrink-0 w-[280px] no-underline"
    >
      <div className="relative h-44 overflow-hidden">
        <img
          src={imageUrl}
          alt={title}
          title={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
        <span className="absolute top-3 right-3 px-2 py-0.5 rounded-md text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
          {hotIndex}°
        </span>
        <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md text-xs bg-black/50 text-background-50 whitespace-nowrap">
          {category}
        </span>
        <div className="absolute bottom-3 left-3 right-3">
          <h3 className="text-sm font-semibold text-background-50 line-clamp-2 leading-snug">
            {title}
          </h3>
          <p className="text-xs text-background-200 mt-1 line-clamp-1">{excerpt}</p>
        </div>
      </div>
      <div className="px-3 py-2.5 flex items-center justify-between">
        <span className="text-xs text-foreground-500">
          <i className="ri-eye-line mr-1 w-3 h-3 inline-flex items-center justify-center"></i>
          {readCount} 阅读
        </span>
        <span className="text-xs text-accent-500 font-medium whitespace-nowrap">阅读全文 →</span>
      </div>
    </Link>
  );
}